import { render } from "./ApplicationStatus.vue?vue&type=template&id=2f80d7ac"
import script from "./ApplicationStatus.vue?vue&type=script&lang=js"
export * from "./ApplicationStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__